import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { get } from 'utils/rest'
import * as Toast from 'components/Toast'

/**
 * Listens for ?test-error=1 in the URL and triggers a real backend error
 * so that the correlated error toast (with Fel-ID and copy button) can be
 * verified without needing to reproduce an actual bug.
 *
 * Only works in non-production environments (the backend returns 404 in production).
 */
export const useTestError = () => {
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('test-error') !== '1') return

    get<string>('/api/test-error').then((res) => {
      if (res.parsedBody?.message) {
        Toast.dispatchToastError({
          message: res.parsedBody.message,
          correlationId: res.parsedBody.correlationId,
        })
      }
    })
  }, [location.search])
}
